module.exports = __webpack_public_path__ + "img/64.a1bf87d2.jpg";